var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('transition',{attrs:{"name":"slidedealer","mode":"in-out"}},[_c('div',{key:_vm.view,staticClass:"transition"},[(!_vm.loading)?_c(_vm.view,{tag:"component"}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }